import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/booking/'

export default {
  getBooking (baseUrl, id) {
    return axios.post(baseUrl + URL + `${id}/get`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  createSupportTicket (baseUrl, data) {
    return axios.get(baseUrl + URL + `createSupportTicket?booking_id=${data.bookingId}&text=${data.text}&type=${data.type}`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  getBookingChangelog (baseUrl, id) {
    return axios.get(baseUrl + URL + `${id}/changelog`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
